module.exports = __webpack_public_path__ + "img/profile.fbf962d2.png";